module.exports = __webpack_public_path__ + "media/images/tiedye/sunset-18000-be9f9324a58293a8201dd5a0e2c5845f.jpg";